import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getBooleanEnvVariable } from '@shared/config/runtime-env';

import type { AppSettingsState } from './types';

const initialState: AppSettingsState = {
	callMinimalMode: getBooleanEnvVariable('REACT_APP_CALL_MINIMAL_MODE'),
};

const appSettingsSlice = createSlice({
	name: 'appSettings',
	initialState,
	reducers: {
		setCallMinimalMode(state, action: PayloadAction<boolean>) {
			state.callMinimalMode = action.payload;
		},
	},
});

export const { setCallMinimalMode } = appSettingsSlice.actions;
export const appSettingsReducer = appSettingsSlice.reducer;
